import { useMemo } from 'react';

import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

// ICONS
import { ReactComponent as AtendenteAusenteIcon } from 'assets/images/eventos/atendente-ausente.svg';
import { ReactComponent as AtendimentoDesafixado } from 'assets/images/eventos/atendimento-desafixado.svg';
import { ReactComponent as AtendimentoFinalizadoIcon } from 'assets/images/eventos/atendimento-finalizado.svg';
import { ReactComponent as AtendimentoFixado } from 'assets/images/eventos/atendimento-fixado.svg';
import { ReactComponent as AtendimentoIniciadoIcon } from 'assets/images/eventos/atendimento-iniciado.svg';
import { ReactComponent as ChamadaVideoPerdidaIcon } from 'assets/images/eventos/chamada-video-perdida.svg';
import { ReactComponent as ChamadaVozPerdidaIcon } from 'assets/images/eventos/chamada-voz-perdida.svg';
import { ReactComponent as InatividadeContatoIcon } from 'assets/images/eventos/inatividade-contato.svg';
import { ReactComponent as MudancaPosicaoAtendimentoIcon } from 'assets/images/eventos/position-atendimento.svg';
import { ReactComponent as TransferenciaAceitaIcon } from 'assets/images/eventos/transferencia-aceita.svg';
import { ReactComponent as TransferenciaRecusadaIcon } from 'assets/images/eventos/transferencia-recusada.svg';
import MessageBase, { MessageBaseProps } from 'components/MessageBase';
import dayjs from 'services/dayjs';
import { TiposEventoMensagemEnum } from 'store/reducers/mensagens';
import { formatDate } from 'utils/formatDate';

type EventMessageProps = MessageBaseProps;

const useStyles = makeStyles(() => ({
  root: ({ eventoDeData }: { eventoDeData?: boolean }) => {
    return {
      display: 'flex',
      alignItems: 'center',
      justifyContent: eventoDeData ? 'center' : 'space-between',
      userSelect: 'none',
      marginTop: -6,
      marginBottom: -6,
    };
  },
}));

const EventoIcon = {
  [TiposEventoMensagemEnum.CHAMADA_VOZ_PERDIDA]: ChamadaVozPerdidaIcon,
  [TiposEventoMensagemEnum.CHAMADA_VIDEO_PERDIDA]: ChamadaVideoPerdidaIcon,
  [TiposEventoMensagemEnum.TRANS_ATENDIMENTO]: TransferenciaAceitaIcon,
  [TiposEventoMensagemEnum.TRANS_ATENDIMENTO_CANCELADO]:
    TransferenciaRecusadaIcon,
  [TiposEventoMensagemEnum.TRANS_ATENDIMENTO_RECUSADO]:
    TransferenciaRecusadaIcon,
  [TiposEventoMensagemEnum.TRANS_ATENDIMENTO_ACEITA]: TransferenciaAceitaIcon,
  [TiposEventoMensagemEnum.ATENDIMENTO_FINALIZADO]: AtendimentoFinalizadoIcon,
  [TiposEventoMensagemEnum.ATENDIMENTO_INICIADO]: AtendimentoIniciadoIcon,
  [TiposEventoMensagemEnum.INATIVIDADE_ATENDENTE]: AtendenteAusenteIcon,
  [TiposEventoMensagemEnum.MUDANCA_POSICAO_ATENDIMENTO]:
    MudancaPosicaoAtendimentoIcon,
  [TiposEventoMensagemEnum.INDISPONIBILIDADE_EQUIPE]: TransferenciaAceitaIcon,
  [TiposEventoMensagemEnum.CONTATO_REMOVIDO]: null,
  [TiposEventoMensagemEnum.CONTATO_ADICIONADO]: null,
  [TiposEventoMensagemEnum.DATA_MENSAGENS]: null,
  [TiposEventoMensagemEnum.ATENDIMENTO_FIXADO]: AtendimentoFixado,
  [TiposEventoMensagemEnum.ATENDIMENTO_DESAFIXADO]: AtendimentoDesafixado,
  [TiposEventoMensagemEnum.INATIVIDADE_CONTATO]: InatividadeContatoIcon,
};

export default function EventMessage(props: EventMessageProps) {
  const {
    mensagem: { mensagem, evento, criadoEm },
  } = props;
  const eventoDeData = evento?.tipo === TiposEventoMensagemEnum.DATA_MENSAGENS;
  const classes = useStyles({ eventoDeData });

  const renderIcon = useMemo(() => {
    if (evento) {
      const EventIcon = EventoIcon[TiposEventoMensagemEnum[evento.tipo]];
      if (EventIcon) return <EventIcon />;
    }
    return null;
  }, [evento]);

  return (
    <MessageBase
      width={eventoDeData ? 'auto' : '500px'}
      maxWidth="100%"
      {...props}
    >
      <Box className={classes.root}>
        <Box display="flex" alignItems="center" gridGap={1}>
          {evento?.tipo !== TiposEventoMensagemEnum.DATA_MENSAGENS &&
            renderIcon}

          {evento?.tipo !== TiposEventoMensagemEnum.DATA_MENSAGENS && (
            <Box pl={2} pr={2} maxWidth={512} overflow="hidden">
              <Typography title={mensagem} component="div" variant="caption">
                {mensagem}
              </Typography>
            </Box>
          )}
        </Box>

        {criadoEm &&
          evento?.tipo !== TiposEventoMensagemEnum.DATA_MENSAGENS && (
            <Typography
              title={dayjs(criadoEm).format('D [de] MMM [de] YYYY [às] HH:mm')}
              variant="caption"
              color="textSecondary"
            >
              {dayjs(criadoEm).format('HH:mm')}
            </Typography>
          )}

        {criadoEm &&
          evento?.tipo === TiposEventoMensagemEnum.DATA_MENSAGENS && (
            <Box
              clone
              fontWeight="600"
              style={{
                textTransform: 'uppercase',
                paddingInline: 16,
                paddingBlock: 2,
              }}
            >
              <Typography variant="caption">{formatDate(criadoEm)}</Typography>
            </Box>
          )}
      </Box>
    </MessageBase>
  );
}
